<template>
  <v-snackbar
    :key="snackbar.shown"
    class="d-print-none"
    :value="snackbar.show"
    :color="snackbar.color"
    :timeout="snackbar.timeout"
    bottom
    right
    @input="onSnackbarClose"
  >
    {{ snackbar.message }}
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="onSnackbarClose"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SnackbarNotification',
  computed: {
    ...mapState(['snackbar'])
  },
  methods: {
    onSnackbarClose() {
      this.$store.commit('showSnackbar', {
        ...this.snackbar,
        show: false
      });
    }
  }
}
</script>